import { buildComponent } from '#components'

const BisTrigger = buildComponent({
  name: 'bis-trigger',
  onConnected: (component) => {
    const bisTriggerEl = component.querySelector('.js-bis-trigger-text-desk')
    if (!bisTriggerEl) return

    const observer = new MutationObserver(() => {
      const BIS_trigger = document.getElementById('BIS_trigger') as HTMLElement
      const BIS_frame = document.getElementById('BIS_frame') as HTMLElement

      if (BIS_trigger && BIS_frame) {
        observer.disconnect()

        bisTriggerEl.addEventListener('click', function() {
          if (BIS_trigger) {
            BIS_trigger.removeAttribute('data-variant-id')
            BIS_trigger.click()
          }
        })

        // Observer to monitor changes in BIS_frame's style
        const styleObserver = new MutationObserver(() => {
          if (BIS_frame.style.display === 'block') {
            document.body.style.overflow = 'hidden' // Disable scroll
          } else {
            document.body.style.overflow = '' // Enable scroll
          }
        })

        styleObserver.observe(BIS_frame, { attributes: true, attributeFilter: ['style'] })
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'bis-trigger': typeof BisTrigger
  }
}
